export function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function numberWithCommas(x) {
  return !x || isNaN(x) ? "" : x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function shorterString(string, maxLength) {
  return string.length > maxLength ? `${string.substring(0, maxLength)}...` : string;
}

export const isEmpty = (str) => !str || !str.trim();

export const titleCase = (str) =>
  str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
